module.exports = __webpack_public_path__ + "fonts/noto-sans-jp-v25-latin-regular.3bd6e5c.eot";